import { isEmail, isRequired, isRequiredContacts } from 'evcharging/app/validation/validators';

export default {
  [isRequired.name]: 'form.error.required',
  [isEmail.name]: 'form.error.email',
  [isRequiredContacts.name]: 'form.error.contacts',
};
